import { IButtonStyles, concatStyleSets, FontWeights } from 'office-ui-fabric-react';
import { AppLayoutSettings } from '../../pages/common.styles';

export const getAppButtonStyles = (customStyles?: Partial<IButtonStyles>): IButtonStyles => {
  const defaultStyles: Partial<IButtonStyles> = {
    root: {
      backgroundColor: AppLayoutSettings.AppColors.primaryWidgetColor,
      color: AppLayoutSettings.AppColors.primaryWidgetLabelColor,
      borderRadius: '2px',
      height: '26px',
      whiteSpace: 'nowrap'
    },
    label: {
      fontSize: AppLayoutSettings.AppFontSize.mediumFontSizePx,
      fontWeight: FontWeights.semibold,
      textAlign: 'center'
    }
  };

  return concatStyleSets(defaultStyles, customStyles);
}

export const getSecondaryButtonOverrideStyles = (): Partial<IButtonStyles> => {
  return {
    root: {
      backgroundColor: AppLayoutSettings.AppColors.whiteColor,
      color: AppLayoutSettings.AppColors.mediumLabelColor,
      border: `1px solid ${AppLayoutSettings.AppColors.blackColor}`
    }
  };
};